import React from "react";
import "./Login.scss";
import { setItem } from "../../util/util";
import http from "../../util/api";
import {Toast, Icon, SearchBar } from "antd-mobile";
import qs from "qs";
import Loading from "../../components/Loading";

class Login extends React.Component {
  state = {
    countDown:0,
    phone:'',
    vCode:''
  }
  async componentDidMount() {
   let phoneNum=sessionStorage.getItem('phone');
   if(phoneNum){
     this.setState({phone:phoneNum});
   }
  }
  
  countDown=()=>{
    let _this=this;
    if(_this.state.phone){
      if(_this.state.phone.length!=11){
        Toast.info('手机号应该是11位');
      }else{
        let s = _this.state.countDown;
        if(s==0){
          s=10;
          let res=_this.sendPhoneNum();
          console.log('res',res)
        }
        _this.setState({countDown:10});
        let t = setInterval(()=>{
          s--;
          console.log(s)
          _this.setState({countDown:s});
          if(s==0){
            clearInterval(t);
          }
        },1000);
      }
    }else{
      Toast.fail('请先填写手机号',1)
    }
    
  }
  sendPhoneNum=async()=>{
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', 'https://towerwx.realsun.me/rsauth/SendValidMsg?telephone='+this.state.phone);
      xhr.send(null);
    });
  }
  sendMsg=async()=>{
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      let obj={
        loginMethod:'mobile',
        useAccessToken:true,
        mobileno:this.state.phone,
        empid:this.state.phone,
        validcode:this.state.vCode
      }
      xhr.open('POST', 'https://tower.realsun.me/api/Account/Login');
      xhr.setRequestHeader('content-type', 'application/json');
      xhr.onload = () => {
        const data = JSON.parse(xhr.response);
        if (xhr.status === 200 && (data.error === 0 || data.error === '0')) {
          resolve(data);
        } else {
          reject(data);
        }
      };
      xhr.send(JSON.stringify(obj));
    });
  }
  login=async()=>{
      if(!this.state.phone){
        Toast.info('您还未填写手机号');
        return false;
      }
      if(this.state.phone.length!=11){
        Toast.info('手机号应该是11位');
        return false;
      }
      if(!this.state.vCode){
        Toast.info('您还未填写验证码');
        return false;
      }
    this.setState({loading:true});
      this.sendMsg().then(
        async(res)=>{
          if(res.ErrorMsg=='短信验证失败'){
            Toast.fail('验证码错误');
            this.setState({loading:false});
          }else{
            setItem("UserCode", res.UserCode);
            setItem("AccessToken", res.AccessToken);
            setItem("SysUserInfo", JSON.stringify(res.SysUserInfo));
            setItem("userInfo", JSON.stringify(res));
            if(res.AccessToken){
              try {
                const res2 = await http().getTable({
                  resid:685988118358
                });
                if(res2.data.data.length!=0){
                  this.props.history.push('/');
              sessionStorage.clear();

                }else{
                  window.localStorage.clear();
                  Toast.fail('该手机号尚未注册',1);
                }
              this.setState({loading:false});
                
              }catch(error){
                console.error(error);
                this.setState({loading:false});
                Toast.fail(error.message);
              }
            }
          }
        }
      )
  }
  render() {
    return (
      <div className="login">
        {this.state.loading?<Loading/>:null}

       {/* <div className='header'>
         <div className='logo'>主页</div>
        </div> */}
        <div className='container'>
              <h3>用户登录</h3>
              <div className='form'>
                <div>
                  <label>手机号：</label><input value={this.state.phone} onChange={(v)=>{sessionStorage.setItem('phone',v.target.value);this.setState({phone:v.target.value});}}/>
                </div>
                <div>
                  <label>验证码：</label><input maxLength={4} value={this.state.vCode} onChange={(v)=>{this.setState({vCode:v.target.value})}}/><div className={this.state.countDown==0?'btn':'btn disabled'} onClick={()=>{this.countDown();}}>{this.state.countDown==0?'发送验证码':this.state.countDown+'秒后重试'}</div>
                </div>
              </div>
              <div>
                <span onClick={()=>{this.props.history.push('/register')}}>新用户注册</span>
                <span onClick={()=>{this.props.history.push('/agreement?showbtn=0')}}>隐私协议</span>
              </div>
        </div>
        
        <div className='mainBtn' onClick={()=>{
                    this.login();
        }}>
          登录
        </div>
      </div>
    );
  }
}

export default Login;
